import CnBarChart from './cn-bar-chart';
import CnChart from './cn-chart';
import CnColumnChart from './cn-column-chart';
import CnDataTable from './cn-data-table';
import CnLineChart from './cn-line-chart';
import CnDualChart from './cn-dual-chart';
import CnPieChart from './cn-pie-chart';
import CnRanking from './cn-ranking';
import CnStatisticCardList from './cn-statistic-card-list';
import CnTile from './cn-tile';

// 通过arr控制输出的顺序
const bundle = [
  CnColumnChart,
  CnBarChart,
  CnLineChart,
  CnDualChart,
  CnPieChart,
  CnStatisticCardList,
  CnDataTable,
  CnTile,
  CnChart,
  CnRanking,
];

window['cn-ui-charts'] = bundle;
export default bundle;
